/* eslint-disable no-console */
import type {NextWebVitalsMetric} from 'next/app';

export const PERF_COOKIE_NAME = 'sw_debug';

const hasPerfCookie = (): boolean => {
    if ('undefined' === typeof document) {
        return false;
    }

    return document.cookie.split(';').some((cookie) => cookie.trim().startsWith(`${PERF_COOKIE_NAME}=`));
};

// eslint-disable-next-line complexity
const getMetricRating = (name: NextWebVitalsMetric['name'], value: number): 'good' | 'needs-improvement' | 'poor' => {
    switch (name) {
        case 'CLS':
            if (0.1 >= value) {
                return 'good';
            }
            if (0.25 >= value) {
                return 'needs-improvement';
            }
            return 'poor';
        case 'LCP':
            if (2500 >= value) {
                return 'good';
            }
            if (4000 >= value) {
                return 'needs-improvement';
            }
            return 'poor';
        case 'FID':
            if (100 >= value) {
                return 'good';
            }
            if (300 >= value) {
                return 'needs-improvement';
            }
            return 'poor';
        case 'INP':
            if (200 >= value) {
                return 'good';
            }
            if (500 >= value) {
                return 'needs-improvement';
            }
            return 'poor';
        case 'FCP':
            if (1800 >= value) {
                return 'good';
            }
            if (3000 >= value) {
                return 'needs-improvement';
            }
            return 'poor';
        case 'TTFB':
            if (800 >= value) {
                return 'good';
            }
            if (1800 >= value) {
                return 'needs-improvement';
            }
            return 'poor';
        default:
            return 'poor';
    }
};

export function reportWebVitals(metric: NextWebVitalsMetric) {
    if ('undefined' === typeof window) {
        return;
    }

    if (!hasPerfCookie()) {
        return;
    }

    const {id, name, label, value} = metric;

    const rating = 'web-vital' === label ? getMetricRating(name, value) : undefined;

    let color = '#0b7285';

    if ('good' === rating) {
        color = '#2f9e44';
    } else if ('needs-improvement' === rating) {
        color = '#f59f00';
    } else if ('poor' === rating) {
        color = '#e03131';
    }

    console.groupCollapsed(`%c[Perf] ${label} – ${name}`, `color:${color};font-weight:bold;`);
    console.log('id:', id);
    console.log('name:', name);
    console.log('label:', label);
    console.log('value:', value);
    if (rating) {
        console.log('rating:', rating);
    }

    const restMetric: Record<string, unknown> = {...metric};
    delete restMetric.id;
    delete restMetric.name;
    delete restMetric.label;
    delete restMetric.value;

    if (Object.keys(restMetric).length) {
        console.log('extra:', restMetric);
    }

    console.groupEnd();
}
